<div class="chart">
  <div class="chart__main">
    <div class="chart__heading">
      Score Trend
      <!-- <mat-select
        (selectionChange)="selectTrendType()"
        [(ngModel)]="selectedTrendType"
      >
        <mat-option
          *ngFor="let trend of trends; index as trendIndex"
          [value]="trendIndex"
          >{{ trend.testType }}
        </mat-option>
      </mat-select> -->
    </div>
    <mat-divider></mat-divider>
    <mat-tab-group
      [(selectedIndex)]="selectedTrendType"
      (selectedTabChange)="selectTrendType()"
    >
      <mat-tab
        *ngFor="let trend of trends; index as trendIndex"
        [label]="trend.testType"
      ></mat-tab>
    </mat-tab-group>
    <ng-container *ngIf="!trendDataLoading; else trendsLoading">
      <p-chart
        type="line"
        [data]="basicData"
        [options]="basicOptions"
        height="200px"
        [plugins]="plugins"
        *ngIf="trends.length > 0; else noTrendsData"
        [responsive]="true"
      ></p-chart>
      <ng-template #noTrendsData>
        <h5>No data to display</h5>
      </ng-template>
    </ng-container>
    <ng-template #trendsLoading>
      <p-progressSpinner> </p-progressSpinner>
    </ng-template>
  </div>
  <div *ngIf="!trendDataLoading" class="chart__main">
    <div class="chart__heading">
      Top Areas to Focus
      <!-- <mat-select
        (selectionChange)="selectQuestionType()"
        [(ngModel)]="selectedStatusType"
      >
        <mat-option
          *ngFor="let stat of status; index as statIndex"
          [value]="statIndex"
          >{{ stat.sectionName }}
        </mat-option>
      </mat-select> -->
    </div>
    <mat-divider></mat-divider>
    <mat-tab-group
      [(selectedIndex)]="selectedStatusType"
      (selectedTabChange)="selectQuestionType()"
    >
      <mat-tab
        *ngFor="let stat of status; index as statIndex"
        [label]="stat.sectionName"
      ></mat-tab>
    </mat-tab-group>
    <ng-container *ngIf="!areaFocusLoading; else areasLoading">
      <div class="chart__legend" *ngIf="status.length > 0">
        <div class="chart__legend__item">
          <div class="chart__legend__item--color"></div>
          <span class="chart__legend__item--text">Correct</span>
        </div>
        <div class="chart__legend__item">
          <div
            class="chart__legend__item--color chart__legend__item--color--wrong"
          ></div>
          <span class="chart__legend__item--text">Incorrect</span>
        </div>
      </div>
      <div
        class="chart__questionStats"
        *ngIf="status.length > 0; else noAreasData"
      >
        <ng-container
          *ngFor="
            let statistic of status[selectedStatusType].questionStatistics
          "
        >
          <span class="chart__questionStats__subtopic">{{
            statistic.subTopic
          }}</span>
          <div class="chart__questionStats__bar">
            <span
              *ngIf="statistic.correctAnswers > 0"
              class="chart__questionStats__bar__item chart__questionStats__bar__item--left chart__questionStats__bar__item--correct"
              [ngClass]="{
                'chart__questionStats__bar__item--right':
                  statistic.wrongAnswers === 0
              }"
              [ngStyle]="{
                width:
                  (statistic.correctAnswers /
                    (statistic.correctAnswers + statistic.wrongAnswers)) *
                    100 +
                  '%'
              }"
              >{{ statistic.correctAnswers }}</span
            >
            <span
              *ngIf="statistic.wrongAnswers > 0"
              class="chart__questionStats__bar__item chart__questionStats__bar__item--right chart__questionStats__bar__item--wrong"
              [ngClass]="{
                'chart__questionStats__bar__item--left':
                  statistic.correctAnswers === 0
              }"
              [ngStyle]="{
                width:
                  (statistic.wrongAnswers /
                    (statistic.correctAnswers + statistic.wrongAnswers)) *
                    100 +
                  '%'
              }"
              >{{ statistic.wrongAnswers }}</span
            >
          </div>
        </ng-container>
      </div>
      <ng-template #noAreasData>
        <h5>No data to display</h5>
      </ng-template>
    </ng-container>
    <ng-template #areasLoading>
      <p-progressSpinner> </p-progressSpinner>
    </ng-template>
  </div>
</div>
